import { get, post,del,put } from '../utils/request';

// 提交拼车送人需求
export const saveRideOrder = (params:any) => {
  return post<any>('/carpool/save_create_carpool_order',params);
};

// 提交拼车送货需求
export const saveDeliveryOrder = (params:any) => {
  return post<any>('/carpool/save_create_delivery_order',params);
};

// 获取拼车送货列表
export const getCarpoolDeliveryList = (params:any) => {
  return get<any>('/carpool/get_delivery_orders',params);
};

// 获取拼车送人列表
export const getCarpoolList = (query:any) => {
  return get<any>('/web/get_all_nearby_carpool_order_list',query);
};  

// 获取拼车会员购买历史
export const getCarpoolMemberPurchaseHistory = (data: any) => {
  const {page_num, page_size} = data;
  return get<any>(`/carpool/get_carpool_member_purchase_history?page_num=${page_num}&page_size=${page_size}`);
};


// 获取拼车送人详情
export const getCarpoolById = (query:any) => {
  return get<any>('/carpool/get_carpool_order_by_id',query);
}; 


  // 获取拼车送货详情
  export const getDeliveryById = (id:any) => {
    return get<any>('/carpool/get_delivery_order/'+id);
  }; 


// 发布人删除拼车送人订单
export const deleteCarpoolOrder = (id:any) => {
  return del<any>(`/carpool/delete_carpool_order/${id}`);
};

// 发布人删除拼车送货订单
export const deleteDeliveryOrder = (id:any) => {
  return del<any>(`/carpool/delete_delivery_order/${id}`);
};

// 发布人取消拼车送人订单
export const cancelCarpoolOrder = (id:any) => {
  return put<any>(`/carpool/cancel_carpool_order/${id}`);
};

// 发布人取消拼车送货订单
export const cancelDeliveryOrder = (id:any) => {
  return put<any>(`/carpool/cancel_delivery_order/${id}`);
};

// 拼车送人竞价
export const saveCreatearpoolrderBidding = (params: any) => {
  return post<any>('/carpool/save_create_carpool_order_bidding', params);
};

// 拼车送人一口价
export const saveFixCarpoolOrder = (params: any) => {
  return post<any>('/carpool/save_fix_carpool_order', params);
};


// 拼车送货竞价
export const saveCreateDeliveryOrderBidding = (params: any) => {
  return post<any>('/carpool/save_create_delivery_order_bidding', params);
};

// 拼车送货一口价
export const saveFixDeliveryOrder = (params: any) => {
  return post<any>('/carpool/save_fix_delivery_order', params);
};



// 删除购物车商品
export const deleteCartProduct = (params:any) => {
  return post<any>('/cart/save_manage_cart',params);
};



// 乘客发起人获取拼车送人订单列表  keyword: 订单号
export const getCarpoolOrderList = (query:any) => {
  return get<any>(`/carpool/get_my_carpool_order_list`,query);
};


// 乘客发起人获取拼车送货订单列表  keyword: 订单号
export const getCarpoolDeliveryOrderList = (query:any) => {
  return get<any>(`/carpool/get_my_delivery_order_list`,query);
};

// 获取司机拼车送人订单列表
export const getDriverCarpoolOrders = (query:any) => {
  return get<any>(`/carpool/get_driver_carpool_orders`,query);
};

// 获取司机拼车送货订单列表
export const getDriverDeliveryOrders = (query:any) => {
  return get<any>(`/carpool/get_driver_delivery_orders`,query);
};


// 获取拼车送人竞价列表 
export const getCarpoolOrderBiddingList = (carpool_order_id: string) => {
  return get<any>(`/carpool/get_carpool_order_bidding_list?carpool_order_id=${carpool_order_id}`);
};

// 获取拼车送货竞价列表 
export const getDeliveryOrderBiddingList = (delivery_order_id: string) => {
  return get<any>(`/carpool/get_delivery_order_bidding_list?delivery_order_id=${delivery_order_id}`);
};


// cart/save_manage_cart
// {
//   "product_list":[
//       {
//           "product_id":"PROD-71ba237aef511753068329140",
//           "product_sku_id":"sku9079849108409807",
//           "quantity":2,
//       }
//   ]
// }




// ❌ 已弃用：Webhook 会自动处理支付成功逻辑
// // 通知拼车送货订单支付成功
// export const notifyDeliveryOrderPaySuccess = (params:any) => {
//   return post<any>('/payment/stripe_payment_success',params);
// };


// // 通知拼车送人订单支付成功
// export const notifyCarpoolOrderPaySuccess = (params:any) => {
//   return post<any>('/carpool/notify_carpool_order_pay_success',params);
// };

// 生成拼车司机订单
export const saveEmergencyServiceOrder = (params: any) => {
  return post<any>('/carpool/save_create_driver_carpool_order', params);
};


// 拼车确认订单
export const carpoolConfirmOrder = (params: any) => {
  return post<any>('/carpool/confirm_order', params);
};


// 司机有责取消拼车订单
export const saveDriverCancellationCarpoolOrder = (params: any) => {
  return post<any>('/carpool/driver_responsible_cancel', params);
};


// 司机有责取消拼车订单并付款成功
export const driverResponsibleCancelAndPaySuccess = (params: any) => {
  return post<any>('/carpool/driver_responsible_cancel_payment_success', params);
};



// 司机删除拼车送人订单
export const deleteDriverCarpoolOrder = (id:any) => {
  return del<any>(`/carpool/delete_driver_carpool_order/${id}`);
};

// 司机删除拼车送货订单
export const deleteDriverDeliveryOrder = (id:any) => {
  return del<any>(`/carpool/delete_driver_delivery_order/${id}`);
};
